import React, { useState, useRef, useEffect } from "react";
import { FaPencilAlt, FaCloudUploadAlt, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "../../header";
import Navvbar from "../../Navvbar";
import "./addNewfile.css";

const API_BASE_URL = "https://hms.backend.hiragroupcloud.com";

const Addnewfile = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [description, setDescription] = useState("");
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  // UI-only fields (backend ko send nahi hote)
  const [practiceName, setPracticeName] = useState("");
  const [replaceExisting, setReplaceExisting] = useState(false);

  // Auto-fill name when file selected
  useEffect(() => {
    if (file && !fileName) {
      // Strip extension for display name
      const base = file.name.replace(/\.[^/.]+$/, "");
      setFileName(base);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  const getUserInfo = () => ({
    userLabId: localStorage.getItem("userLabId") || "",
    userId: localStorage.getItem("userId") || "",
    userName: localStorage.getItem("userName") || "Unknown",
    labName: localStorage.getItem("labName") || "",
    token:
      localStorage.getItem("accessToken") ||
      localStorage.getItem("token") ||
      ""
  });

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    if (f) {
      setFile(f);
      setFileName(f.name.replace(/\.[^/.]+$/, ""));
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSave = async () => {
    if (!file) {
      toast.warn("Please select a file");
      return;
    }

    setUploading(true);
    setProgress(0);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("description", description || "");
    // Optional: use custom name if you want
    // formData.append("customName", fileName || "");

    const { userLabId, userId, userName, labName, token } = getUserInfo();
    formData.append("userLabId", userLabId);
    formData.append("userId", userId);
    formData.append("userName", userName);
    formData.append("labName", labName);

    try {
      await axios.post(
        `${API_BASE_URL}/api/viewer-files/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
          onUploadProgress: (evt) => {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            setProgress(pct);
          }
        }
      );

      toast.success("File uploaded successfully");
      navigate("/file");
    } catch (err) {
      console.error("Upload error:", err);
      toast.error(err.response?.data?.message || "Failed to upload file");
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div className="container-fluid anf-container">
        <div className="row anf-row">
          {/* Sidebar Section */}
          <div className="col-md-2 anf-sidebar">
            <h2 className="anf-sidebar-title">Dashboard</h2>
            <Link to="/file" className="anf-sidebar-link">
              Files
            </Link>
          </div>

          {/* Main Content Section */}
          <div className="col-md-10 anf-main">
            <h2 className="anf-title">Add New File</h2>

            {/* Practice Section */}
            <div className="anf-block">
              <h4 className="anf-heading">Practice</h4>
              <div className="anf-box">
                <div className="anf-field">
                  <label className="anf-label">
                    Practice <span className="anf-required">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Practice Name"
                    className="anf-input anf-input-practice"
                    value={practiceName}
                    onChange={(e) => setPracticeName(e.target.value)}
                    disabled={uploading}
                  />
                </div>
              </div>
            </div>

            {/* File Section */}
            <div className="anf-block">
              <h4 className="anf-heading">File</h4>
              <div className="anf-box">
                {/* File input */}
                <div className="anf-field">
                  <label className="anf-label">
                    File <span className="anf-required">*</span>
                  </label>
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="anf-input anf-input-file"
                    onChange={handleFileChange}
                    disabled={uploading}
                    accept=".stl,.ply,.obj,.3mf,.png,.jpg,.jpeg,.jfif,.gif,.webp,.bmp,.tiff,.tif,.svg,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.7z"
                  />
                </div>

                {file && (
                  <div className="anf-field anf-file-info-row">
                    <label className="anf-label"></label>
                    <div className="anf-file-info">
                      <FaCloudUploadAlt style={{ color: "#004aad" }} />
                      <span>
                        <b>{file.name}</b> (
                        {(file.size / (1024 * 1024)).toFixed(2)} MB)
                      </span>
                      <button
                        type="button"
                        onClick={handleRemoveFile}
                        disabled={uploading}
                        className="anf-remove-btn"
                        title="Remove file"
                      >
                        <FaTrash /> Remove
                      </button>
                    </div>
                  </div>
                )}

                {/* File Name input (display only — actual filename comes from file) */}
                <div className="anf-field">
                  <label className="anf-label">Name</label>
                  <input
                    type="text"
                    placeholder="File name"
                    className="anf-input"
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                    disabled={uploading}
                  />
                </div>

                {/* Description input */}
                <div className="anf-field anf-field-desc">
                  <label className="anf-label anf-label-desc">Description</label>
                  <textarea
                    placeholder="File description"
                    className="anf-input anf-textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={uploading}
                  />
                </div>

                {/* Replace existing files */}
                <div className="anf-field">
                  <label className="anf-label anf-label-replace">
                    Replace existing files?
                  </label>
                  <input
                    type="checkbox"
                    className="anf-checkbox"
                    checked={replaceExisting}
                    onChange={(e) => setReplaceExisting(e.target.checked)}
                    disabled={uploading}
                  />
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="anf-save-wrap">
              <button
                className="anf-save-btn"
                onClick={handleSave}
                disabled={uploading || !file}
                style={{
                  opacity: uploading || !file ? 0.6 : 1,
                  cursor: uploading || !file ? "not-allowed" : "pointer"
                }}
              >
                <FaPencilAlt className="anf-save-icon" />
                {uploading ? `Saving... ${progress}%` : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addnewfile;